$(document).ready(function () {
  async function updateCartDrawer() {
    const res = await fetch("/?section_id=add-cart-popup");
    const text = await res.text();

    const html = document.createElement("div");
    html.innerHTML = text;

    const newBox = html.querySelector(".cart-drawer").innerHTML;

    document.querySelector(".cart-drawer").innerHTML = newBox;
    changeItemCounter();
    addCartEventListeners();
  }

  function changeItemCounter(){
    axios
    .get("/cart.js")
    .then(function (response) {
        document.querySelector("#CartCount").innerHTML = '<span data-cart-count="">' + response.data.item_count + '</span>';
    });
  }

  function addCartEventListeners() {
    document.querySelectorAll(".item-count-edit button").forEach((button) => {
      button.addEventListener("click", (e) => {
        const isPlus = button.classList.contains("cart-quantity-increase");
        const input = button.parentElement.querySelector("input");
        const value = Number(input.value);
        const key = button.closest(".cart-item").getAttribute("data-key");
        e.preventDefault();

        if (isPlus) {
          const newValue = value + 1;
          input.value = newValue;
          changeItemQuantity(key, newValue);
        } else if (value > 1) {
          const newValue = value - 1;
          input.value = newValue;
          changeItemQuantity(key, newValue);
        }
      });
    });

    document.querySelectorAll(".remove-cart-item").forEach((remove) => {
      remove.addEventListener("click", (e) => {
        e.preventDefault();
        const item = remove.closest(".cart-item");
        const key = item.getAttribute("data-key");

        axios
          .post("/cart/change.js", {
            id: key,
            quantity: 0,
          })
          .then((res) => {
            item.remove();
            const format = document
              .querySelector("[data-money-format]")
              .getAttribute("data-money-format");
            const totalPrice = formatMoney(res.data.total_price, format);
            document.querySelector("#total-price").textContent = totalPrice;
            updateCartDrawer();
          });
      });
    });

    $('.btn--add-to-cart-popup').on('click', function() {
      let selectedUpsellSize = $('.upsellSelectForm').val();
      let upsellFormData = {
       items: [
         {
           id: selectedUpsellSize,
           quantity: 1,
         },
       ],
     };
   
       fetch(window.Shopify.routes.root + "cart/add.js", {
         method: "POST",
         headers: {
           "Content-Type": "application/json",
         },
         body: JSON.stringify(upsellFormData),
       })
       .then((response) => {
         updateCartDrawer();
         return response.json();
       })
       .catch((error) => {
         console.error("Error:", error);
       });
     });

  }

  $('#productSelectTwo').on("change", function(){
    let selectedVariantPrice = $('#productSelectTwo option:selected').data("variant-price");
    let selectedVariantId = $('#productSelectTwo option:selected').data("id");
    let selectedVariantAvailability = $('#productSelectTwo option:selected').data("available");

    if(selectedVariantId === 44685294567692 || selectedVariantId === 54540698485004){
      $('.reference-price-100g-2').html('18€ / 100g')
      $('#product-page-new-design > div:nth-child(2) > div.product__price.kakao-price-two > div').html(`<span style="color: var(--color-btn-primary);">${selectedVariantPrice}</span>` + " " + "<span class='angebot-label'>Exklusiv</span>")
    } else if (selectedVariantId == 202020) {
      $('.reference-price-100g-2').html('14,52€ / 100g')
      $('#product-page-new-design > div:nth-child(2) > div.product__price.kakao-price-two > div').html(`<span class="gradient-pricetag" style="color: transparent; background-clip: text">${selectedVariantPrice}</span>` + " " + "<span class='angebotspreis-strikethrough' style='display: inline-block; margin: 0 10px'>76,-</span><span class='angebot-label gradient-pricetag'>Angebot</span>")
    } else if (selectedVariantId == 303030) {
      $('.reference-price-100g-2').html('12,62€ / 100g')
      $('#product-page-new-design > div:nth-child(2) > div.product__price.kakao-price-two > div').html(`<span class="gradient-pricetag" style="color: transparent; background-clip: text">${selectedVariantPrice}</span>` + " " + "<span class='angebotspreis-strikethrough' style='display: inline-block; margin: 0 10px'>76,-</span><span class='angebot-label gradient-pricetag'>Bestseller Angebot</span>")
    }

    if(selectedVariantAvailability == 'soldout'){
      $('#add-to-cart-kakao').css("display", "none");
      $('#disabled-add-to-cart-kakao').css("display", "inline-block");
    } else {
      $('#disabled-add-to-cart-kakao').css("display", "none");
      $('#add-to-cart-kakao').css("display", "inline-block");
    }

  })
  
    const selectedVariantPriceOnLoadKakao = $('#productSelectTwo option:selected').data("variant-price");
    const selectedVariantIdOnLoadKakao = $('#productSelectTwo option:selected').data("id");
    const selectedVariantAvailabilityOnLoadKakao = $('#productSelectTwo option:selected').data("available");

    if(selectedVariantIdOnLoadKakao === 44685294567692 || selectedVariantIdOnLoadKakao === 54540698485004){
      $('#product-page-new-design > div:nth-child(2) > div.product__price.kakao-price-two > div').html(`<span style="color: var(--color-btn-primary);">${selectedVariantPriceOnLoadKakao}</span>` + " " + "<span class='angebot-label'>Exklusiv</span>");
      $('.reference-price-100g-2').html('18€ / 100g')
    } else if (selectedVariantIdOnLoadKakao == 202020) {
      $('#product-page-new-design > div:nth-child(2) > div.product__price.kakao-price-two > div').html(`<span class="gradient-pricetag" style="color: transparent; background-clip: text">${selectedVariantPriceOnLoadKakao}</span>` + " " + "<span class='angebotspreis-strikethrough' style='display: inline-block; margin: 0 10px'>76,-</span><span class='angebot-label gradient-pricetag'>Angebot</span>");
      $('.reference-price-100g-2').html('14,52€ / 100g')
    } else if (selectedVariantIdOnLoadKakao == 303030) {
      $('#product-page-new-design > div:nth-child(2) > div.product__price.kakao-price-two > div').html(`<span class="gradient-pricetag" style="color: transparent; background-clip: text">${selectedVariantPriceOnLoadKakao}</span>` + " " + "<span class='angebotspreis-strikethrough' style='display: inline-block; margin: 0 10px'>76,-</span><span class='angebot-label gradient-pricetag'>Bestseller Angebot</span>")
      $('.reference-price-100g-2').html('12,62€ / 100g')
    }

    if(selectedVariantAvailabilityOnLoadKakao == 'soldout'){
      $('#add-to-cart-kakao').css("display", "none");
      $('#disabled-add-to-cart-kakao').css("display", "inline-block");
    } else {
      $('#disabled-add-to-cart-kakao').css("display", "none");
      $('#add-to-cart-kakao').css("display", "inline-block");
    }

    const selectedVariantPriceOnLoad = $('#productSelectKakao option:selected').data("variant-price");
    const selectedVariantIdOnLoad = $('#productSelectKakao option:selected').data("id");
    const selectedVariantAvailabilityOnLoad = $('#productSelectKakao option:selected').data("available");
    
    
    if(selectedVariantIdOnLoad === 44685294567692 || selectedVariantIdOnLoad === 54540698485004){
      $('#product-page-new-design > div:nth-child(2) > div.kakao-price-one > div').html(`<span style="color: var(--color-btn-primary);">${selectedVariantPriceOnLoad}</span>` + " " + "<span class='angebot-label'>Exklusiv</span>");
      $('.reference-price-100g').html('18€ / 100g')
    } else if (selectedVariantIdOnLoad == 202020) {
      $('#product-page-new-design > div:nth-child(2) > div.kakao-price-one > div').html(`<span class="gradient-pricetag" style="color: transparent; background-clip: text">${selectedVariantPriceOnLoad}</span>` + " " + "<span class='angebotspreis-strikethrough' style='display: inline-block; margin: 0 10px'>76,-</span><span class='angebot-label gradient-pricetag'>Angebot</span>");
      $('.reference-price-100g').html('14,52€ / 100g')
    } else if (selectedVariantIdOnLoad == 303030) {
      $('#product-page-new-design > div:nth-child(2) > div.kakao-price-one > div').html(`<span class="gradient-pricetag" style="color: transparent; background-clip: text">${selectedVariantPriceOnLoad}</span>` + " " + "<span class='angebotspreis-strikethrough' style='display: inline-block; margin: 0 10px'>76,-</span><span class='angebot-label gradient-pricetag'>Bestseller Angebot</span>")
      $('.reference-price-100g').html('12,62€ / 100g')
    }

    if(selectedVariantAvailabilityOnLoad == 'soldout'){
      $('#add-to-cart').css("display", "none");
      $('#disabled-add-to-cart').css("display", "inline-block");
    } else {
      $('#disabled-add-to-cart').css("display", "none");
      $('#add-to-cart').css("display", "inline-block");
    }

  $('#productSelectKakao').on("change", function(){
    let selectedVariantPrice = $('#productSelectKakao option:selected').data("variant-price");
    let selectedVariantId = $('#productSelectKakao option:selected').data("id");
    let selectedVariantAvailability = $('#productSelectKakao option:selected').data("available");
    let variantLabel = "Exklusiv"
    
    if(selectedVariantId === 44685294567692 || selectedVariantId === 54540698485004){
      $('.reference-price-100g').html('18€ / 100g')
      variantLabel = "Exklusiv"
      $('#product-page-new-design > div:nth-child(2) > div.kakao-price-one > div').html(`<span style="color: var(--color-btn-primary);">${selectedVariantPrice}</span>` + " " + `<span class='angebot-label'>${variantLabel}</span>`)
    } else if (selectedVariantId == 202020) {
      $('.reference-price-100g').html('14,52€ / 100g')
      variantLabel = "Angebot"
      $('#product-page-new-design > div:nth-child(2) > div.kakao-price-one > div').html(`<span class="gradient-pricetag" style="color: transparent; background-clip: text">${selectedVariantPrice}</span>` + " " + "<span class='angebotspreis-strikethrough' style='display: inline-block; margin: 0 10px'>76,-</span>" + `<span class='angebot-label gradient-pricetag'>${variantLabel}</span>`)
    } else if (selectedVariantId == 303030) {
      $('.reference-price-100g').html('12,62€ / 100g')
      variantLabel = "Bestseller Angebot"
      $('#product-page-new-design > div:nth-child(2) > div.kakao-price-one > div').html(`<span class="gradient-pricetag" style="color: transparent; background-clip: text">${selectedVariantPrice}</span>` + " " + "<span class='angebotspreis-strikethrough' style='display: inline-block; margin: 0 10px'>76,-</span>" + `<span class='angebot-label gradient-pricetag'>${variantLabel}</span>`)
    }


    if(selectedVariantAvailability == 'soldout'){
      $('#add-to-cart').css("display", "none");
      $('#disabled-add-to-cart').css("display", "inline-block");
    } else {
      $('#disabled-add-to-cart').css("display", "none");
      $('#add-to-cart').css("display", "inline-block");
    }
  })

  

  $('#add-to-cart').on('click', function() {
  let mainVariantId = $('#add-to-cart').data("variant-id");

    let upsellVariantId = $(".upsell-wrapper").data("upsell-product");
    const upsellChecked = $("#upsell-button-yes").is(":checked");
    let formData;

    if (upsellChecked) {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: 1,
          },
          {
            id: upsellVariantId,
            quantity: 1,
          },
        ],
      };
    } else {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: 1,
          },
        ],
      };
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      updateCartDrawer();
      openCartDrawer();
      changeItemCounter()    
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  });



  $('.add-to-cart-variants').on('click', function() {
  let mainVariantId = $('.add-to-cart-variants').data("variant-id");
    // Get the current value of data-variant-id when the button is clicked
    console.log(mainVariantId);
    let selectedOptionValue = $('#productSelect').val();
    console.log(selectedOptionValue)

    if(mainVariantId !== selectedOptionValue){
      mainVariantId = selectedOptionValue
    }

    let upsellVariantId = $(".upsell-wrapper").data("upsell-product");
    const upsellChecked = $("#upsell-button-yes").is(":checked");
    let formData;

    if (upsellChecked) {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: 1,
          },
          {
            id: upsellVariantId,
            quantity: 1,
          },
        ],
      };
    } else {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: 1,
          },
        ],
      };
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      updateCartDrawer();
      openCartDrawer();    
      changeItemCounter()    
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  });

  $('.add-to-cart-variants-kakao').on('click', function() {
  let mainVariantId = $('.add-to-cart-variants-kakao').data("variant-id");
    // Get the current value of data-variant-id when the button is clicked
    console.log(mainVariantId);
    let selectedVariantQuantity = $('#productSelectTwo option:selected').data("quantity");

    let selectedOptionValue = $('#productSelectTwo').val();
    console.log(selectedOptionValue)

    if(mainVariantId !== selectedOptionValue){
      mainVariantId = selectedOptionValue
    }

    let upsellVariantId = $(".upsell-wrapper").data("upsell-product");
    const upsellChecked = $("#upsell-button-yes").is(":checked");
    let formData;

    if (upsellChecked) {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: selectedVariantQuantity,
          },
          {
            id: upsellVariantId,
            quantity: selectedVariantQuantity,
          },
        ],
      };
    } else {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: selectedVariantQuantity,
          },
        ],
      };
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      updateCartDrawer();
      openCartDrawer();    
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  });

  $('.add-to-cart-variants-kakao-two').on('click', function() {

  let mainVariantId = $('.add-to-cart-variants-kakao-two').data("variant-id");
    // Get the current value of data-variant-id when the button is clicked
    let selectedVariantQuantity = $('#productSelectKakao option:selected').data("quantity");
    console.log(selectedVariantQuantity);
    console.log(mainVariantId);
    let selectedOptionValue = $('#productSelectKakao').val();
    console.log(selectedOptionValue)

    if(mainVariantId !== selectedOptionValue){
      mainVariantId = selectedOptionValue
    }

    let upsellVariantId = $(".upsell-wrapper").data("upsell-product");
    const upsellChecked = $("#upsell-button-yes").is(":checked");
    let formData;

    if (upsellChecked) {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: selectedVariantQuantity,
          },
          {
            id: upsellVariantId,
            quantity: selectedVariantQuantity,
          },
        ],
      };
    } else {
      formData = {
        items: [
          {
            id: mainVariantId,
            quantity: selectedVariantQuantity,
          },
        ],
      };
    }

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    .then((response) => {
      updateCartDrawer();
      openCartDrawer();    
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
  });


 

  addItemToCartById()
  addCartEventListeners();
  variantAltAddItemToCart()

  function formatMoney(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        ),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

function changeItemQuantity(key, quantity) {
  axios
    .post("/cart/change.js", {
      id: key,
      quantity,
    })
    .then(() => {
      return axios.get("/cart.js");
    })
    .then((res) => {
      const cart = res.data;
      const format = document
        .querySelector("[data-money-format]")
        .getAttribute("data-money-format");

      const totalItems = cart.item_count;
      const totalPrice = formatMoney(cart.total_price, format);

      document.querySelector("#CartCount").innerHTML =
        '<span data-cart-count="">' + totalItems + "</span>";
      document.querySelector("#total-price").textContent = totalPrice;

      // ✅ This line is the missing piece
      updateCartDrawer();
    })
    .catch((err) => console.error("Cart update failed:", err));
}

  function addItemToCartById(){
    document.querySelectorAll('.add-to-cart-by-id').forEach((button) => {
      button.addEventListener('click', () => {
        let formData = {
          'items': [{
            'id': button.dataset.productToSell,
            'quantity': 1
          }]        
        };
  
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          updateCartDrawer();
          openCartDrawer();    
          changeItemCounter()    
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      });
    });
  }

  function variantAltAddItemToCart(){
    document.querySelectorAll('.add-to-cart-by-id-variant').forEach((button) =>  {
      button.addEventListener('click', () => {
        let value = document.getElementById('alt-product-select').value;
        let formData = {
          'items': [{
            'id': value,
            'quantity': 1
          }]        
        };
  
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          updateCartDrawer();
          openCartDrawer();    
          changeItemCounter()    
          return response.json();
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      })
    })
  }

});

